/* Apply the stock policy to catalog links and forms, including dynamic sections. */
(() => {
  'use strict';
  const script = document.currentScript;
  const collectionsPath = script.dataset.collectionsUrl.replace(/\/$/, '') + '/';
  const searchPath = script.dataset.searchUrl.replace(/\/$/, '');

  function catalogUrl(href) {
    if (!href || href.startsWith('#')) return null;
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return null;
    if (url.pathname.replace(/\/$/, '') === searchPath) {
      url.searchParams.set('options[unavailable_products]', 'hide');
      url.searchParams.delete('filter.v.availability');
    } else if (url.pathname.startsWith(collectionsPath) && !url.pathname.includes('/products/')) {
      url.searchParams.set('filter.v.availability', '1');
    } else {
      return null;
    }
    return url.pathname + url.search + url.hash;
  }

  function updateLink(link) {
    const href = link.getAttribute('href');
    const next = catalogUrl(href);
    if (next && next !== href) link.setAttribute('href', next);
  }

  function updateForm(form) {
    if ((form.method || 'get').toLowerCase() !== 'get') return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || action.pathname.replace(/\/$/, '') !== searchPath) return;
    let input = form.querySelector('input[name="options[unavailable_products]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'options[unavailable_products]';
      form.append(input);
    }
    input.value = 'hide';
    form.querySelectorAll('[name="filter.v.availability"]').forEach((field) => { field.disabled = true; });
  }

  function updateTree(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root.matches?.('a[href]')) updateLink(root);
    if (root.matches?.('form')) updateForm(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
    root.querySelectorAll('form').forEach(updateForm);
  }

  updateTree(document);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (link) updateLink(link);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) updateForm(event.target);
  }, true);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(updateTree));
  }).observe(document.body, { childList: true, subtree: true });
})();
